const zh = {
  nav: {
    features: '功能',
    pricing: '价格',
    signIn: '登录',
    getStarted: '立即开始',
    home: '首页',
    dashboard: '仪表板',
    quotations: '报价单',
    invoices: '发票',
    receipts: '收据',
    bills: '账单',
    documents: '所有文档',
    docGroup: '文档',
    newDoc: '新建',
    support: '支持',
    supportCases: '支持工单',
    clients: '客户',
    items: '项目',
    settings: '设置',
    subscription: '订阅',
    profile: '个人资料',
    admin: '管理员',
    system: '系统',
    users: '用户',
    userStats: '用户统计',
    finance: '财务',
    activity: '活动日志',
    backups: '备份',
    changelog: '版本历史',
    signOut: '退出登录',
    viewProfile: '查看个人资料',
    collapse: '收起',
    light: '浅色',
    dark: '深色',
    full: '全屏',
    exit: '退出',
    recurring: '定期发票',
  },
  hero: {
    eyebrow: '商业文档管理',
    headline1: '报价单、发票',
    headline2: '和收据。',
    headline3: '专业制作。',
    sub: '不再为 Word 模板和电子表格烦恼。Invio 提供品牌化 PDF、客户管理、多币种支持以及 30 天免费试用。',
    ctaPrimary: '开始 30 天免费试用 →',
    ctaSecondary: '查看价格',
    trust: '✓ 无需信用卡  ·  ✓ 随时取消  ·  ✓ 60 秒完成设置',
  },
  stats: {
    docTypes: '文档类型',
    currencies: '支持货币',
    languages: '语言',
    docsPerMo: '每月文档数',
    dayTrial: '天免费试用',
  },
  features: {
    eyebrow: '功能',
    title: '为客户开具账单所需的一切',
    sub: '一款工具,处理所有商业文档 — 没有附加项,没有捆绑销售。',
    items: {
      quotations:    { title: '报价单',         desc: '发送精美提案,一键转换为发票。' },
      invoices:      { title: '发票',           desc: '为客户开具自动编号、品牌化的 PDF 发票,几秒即可完成。' },
      receipts:      { title: '收据',           desc: '开具与发票完全匹配的付款收据。' },
      bills:         { title: '供应商账单',     desc: '与客户应收账款一并跟踪供应商账单。' },
      purchase:      { title: '采购与送货单',   desc: '为采购或发货商品创建采购订单和送货单。' },
      credit:        { title: '贷记凭证',       desc: '开具退款和调整凭证,保留完整记录。' },
      clients:       { title: '客户通讯录',     desc: '可重复使用的客户记录,自动填充每份文档。' },
      multiCurrency: { title: '多币种',         desc: '{count} 种货币,包括美元、欧元、马来西亚林吉特、人民币以及阿拉伯联盟所有货币。' },
      export:        { title: 'PDF 与 Word 导出',desc: '为每种文档类型提供可打印 PDF 和可编辑 .docx。' },
    },
  },
  pricing: {
    eyebrow: '价格',
    title: '简单、透明的价格',
    sub: '从 30 天免费试用开始。无需信用卡。',
    monthly: '按月付费',
    yearly: '按年付费',
    perMonth: '/月',
    perYear: '/年',
    save: '节省 {p}%',
    cta: '开始免费试用',
    custom: '定制',
    customPrice: '联系我们',
    customSub: '为您的团队量身定制',
    contactUs: '联系我们',
    plan: {
      monthly: { f1: '无限文档', f2: 'AI 项目提取', f3: 'PDF 与 Word 导出', f4: '随时取消' },
      yearly:  { f1: '相当于 {amount}/月', f2: '无限文档', f3: 'AI 项目提取', f4: 'PDF 与 Word 导出' },
      custom:  { f1: '定制功能和集成', f2: '批量折扣', f3: '优先支持', f4: '多用户团队账户' },
    },
  },
  finalCta: {
    title: '准备好发送您的第一份发票了吗?',
    sub: '60 秒内设置好您的公司资料。今天就开具您的第一份报价单。',
    button: '免费开始 →',
  },
  footer: {
    tagline: '为小型团队提供专业的商业文档管理。',
    product: '产品',
    account: '账户',
    contact: '联系我们',
    createAccount: '创建账户',
    legal: '法律条款',
    terms: '服务条款',
    privacy: '隐私政策',
    refund: '退款政策',
    copyright: '© {year} Invio · invio.my',
  },
  banner: {
    verifyEmail: '⚠ 请验证您的邮箱。',
    weSentLink: '我们已将确认链接发送至',
    resend: '重新发送邮件',
    sending: '发送中…',
    deactivated: '您的账户已被停用。请联系管理员。',
    trialEnded: '您的试用期已结束',
    graceDaysLeft: '您还有 {d} 天宽限期。订阅以继续使用 Invio。',
    subscribeNow: '立即订阅',
    paymentFailed: '付款失败',
    paymentFailedMsg: '我们无法从您的卡中扣款。请在 {d} 天内更新付款方式以保留访问权限。',
    updatePayment: '更新付款方式',
    trialExtended: '您的试用期已延长',
    trialExtendedBy: '我们为您增加了 {d} 天。您的试用期现在将于 {date} 结束。',
    dismiss: '关闭',
  },
  emailPrefs: {
    title: '电子邮件通知',
    subtitle: '选择我们向您发送哪些可选邮件。',
    securityAlerts: '新登录提醒',
    securityAlertsDesc: '当我的账户从新设备或浏览器登录时通过邮件通知我。',
    announcements: '产品更新',
    announcementsDesc: '关于 Invio 新功能和改进的偶尔资讯。',
    transactionalNote: '必要邮件——验证、密码重置、安全验证码、账单和试用通知——始终会发送。',
  },
  sessions: {
    title: '活动会话',
    subtitle: '已登录您账户的设备——退出任何您不认识的设备。',
    activeDevices: '已登录设备',
    none: '没有其他活动会话。',
    thisDevice: '当前设备',
    lastActive: '最后活动于 {when}',
    revoke: '退出',
    signOutOthers: '退出所有其他设备',
    now: '刚刚',
    minAgo: '{n} 分钟前',
    hrAgo: '{n} 小时前',
  },
  twofa: {
    title: '两步验证',
    enterAppCode: '请输入验证器应用中的 6 位验证码。',
    enterEmailCode: '我们已通过电子邮件发送 6 位验证码，请在下方输入。',
    trustDevice: "30 天内在此设备上不再询问",
    verify: '验证',
    resend: '重新发送验证码',
    codeSent: '验证码已发送 ✓',
    section: '双重认证（2FA）',
    sectionSub: '登录时的第二道验证，即使密码泄露也能保护您的账户。',
    statusOff: '未启用',
    statusApp: '已启用 — 验证器应用',
    statusEmail: '已启用 — 邮件验证码',
    useApp: '使用验证器应用',
    useEmail: '使用邮件验证码',
    scanQr: '使用 Google Authenticator、Microsoft Authenticator、Authy 或任何 TOTP 应用扫描此二维码。',
    manualKey: '或手动输入此密钥：',
    thenEnter: '然后输入应用显示的 6 位验证码：',
    activate: '启用',
    emailSent: '我们已向 {email} 发送 6 位验证码，输入后即可启用邮件验证码。',
    enabled: '双重认证已启用',
    disabled: '双重认证已关闭',
    activeApp: '登录时需要输入验证器应用中的验证码。',
    activeEmail: '登录时需要输入发送到您邮箱的验证码。',
    turnOff: '关闭',
    confirmPassword: '请输入密码以关闭双重认证：',
  },
  auth: {
    signInTab: '登录',
    registerTab: '注册',
    welcomeBack: '欢迎回来',
    createAccountTitle: '创建账户',
    signInSub: '登录以管理您的商业文档。',
    registerSub: '今天就开始使用 Invio。',
    fullName: '姓名',
    fullNamePlaceholder: '您的姓名',
    email: '电子邮箱',
    emailPlaceholder: 'you@example.com',
    password: '密码',
    passwordPlaceholder: '••••••••',
    rememberMe: '记住我',
    forgotPassword: '忘记密码?',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    pleaseWait: '请稍候…',
    signInBtn: '登录',
    createAccountBtn: '创建账户',
    invalidCredentials: '邮箱或密码错误。',
    weakPassword: '密码不符合安全要求。',
    backToSignIn: '返回登录',
    resetTitle: '重置密码',
    resetIntro: '输入与您账户关联的邮箱地址,我们将发送重置链接。',
    sendResetLink: '发送重置链接',
    checkInbox: '请检查您的收件箱',
    ifRegistered: '如果 {email} 已注册,密码重置链接已发送。',
    backToSignInBtn: '返回登录',
    resetSendFailed: '无法发送重置链接。请重试。',
    resetSpamHint: '链接将在 1 小时后失效。如果几分钟内未收到邮件，请检查垃圾邮件文件夹。',
    agree: '创建账户即表示您同意我们的{terms}和{privacy}。',
    tagline: '专业的商业文档管理 — 报价单、发票、收据等。',
    feature1: '报价单与发票',
    feature2: '客户管理',
    feature3: 'PDF 与 Word 导出',
  },
  docType: {
    quotation: '报价单', invoice: '发票', bill: '供应商账单', receipt: '收据',
    purchase_order: '采购单', delivery_order: '送货单',
    credit_note: '贷记单', statement: '对账单',
  },
  status: {
    draft: '草稿', sent: '已发送', accepted: '已接受', rejected: '已拒绝',
    paid: '已付款', overdue: '逾期', cancelled: '已取消',
    partial: '部分付款',
  },
  doc: {
    description: '描述', qty: '数量', unitPrice: '单价', amount: '金额',
    subtotal: '小计', discount: '折扣', tax: '税额', total: '总计',
  },
  docs: {
    allDocuments: '所有文档',
    titlePlural: {
      quotation: '报价单', invoice: '发票', bill: '供应商账单', receipt: '收据',
      purchase_order: '采购单', delivery_order: '送货单',
      credit_note: '贷记单', statement: '对账单',
    },
    count: '{n} 份文档',
    document: '文档',
    newType: '新建{type}',
    searchPlaceholder: '按编号或客户搜索…',
    allTypes: '所有类型',
    allStatus: '所有状态',
    noneFound: '未找到{title}',
    createFirst: '创建您的第一份{type}',
    thType: '类型', thNumber: '编号', thClient: '客户', thDate: '日期',
    thAmount: '金额', thStatus: '状态', thActions: '操作',
    view: '查看', edit: '编辑', copy: '复制', del: '删除',
    confirmDelete: '删除此文档？',
    duplicateFailed: '无法复制文档',
  },
  editor: {
    editTitle: '编辑{type}',
    newTitle: '新建{type}',
    saveChanges: '保存更改',
    createDocument: '创建文档',
    documentDetails: '文档详情',
    documentType: '文档类型',
    status: '状态',
    issueDate: '开具日期',
    validUntil: '有效期至',
    dueDate: '到期日',
    referenceNumber: '参考编号',
    auto: '自动',
    manual: '手动',
    autoGenerated: '将自动生成（例如 QT-2026-0001）',
    supplierBillTo: '供应商与收单方',
    client: '客户',
    supplierName: '供应商名称',
    supplierNamePh: '供应商公司名称',
    supplierAddress: '供应商地址',
    supplierAddressPh: '供应商地址',
    billToClient: '收单方（客户）',
    selectClientPh: '选择客户…',
    selectClient: '选择客户',
    noClient: '— 无客户 —',
    addClient: '+ 添加客户',
    items: '项目',
    titleOptional: '标题（可选）',
    titlePh: '例如：ABC 项目 – 第一阶段',
    hidePrices: '在此送货单上隐藏价格',
    hidePricesHint: '将从 PDF 和 Word 文件中移除单价和金额列以及所有合计。已输入的价格会保留，取消勾选即可恢复显示。',
    itemDescriptionPh: '项目描述',
    saveAsItem: '保存为可复用项目',
    removeRow: '删除行',
    addItem: '+ 添加项目',
    fromSaved: '从已保存',
    notesTerms: '备注与条款',
    notesLabel: '备注（客户可见）',
    notesPh: '感谢您的惠顾…',
    termsLabel: '条款与条件',
    termsPh: '付款条款、交货条件…',
    includeSignature: '在 PDF 中包含签名栏',
    currencyPricing: '货币与定价',
    currency: '货币',
    taxRatePct: '税率 (%)',
    discountType: '折扣类型',
    fixed: '固定金额',
    percent: '百分比',
    discountValue: '折扣值',
    summary: '汇总',
    pricesHiddenEditorNote: '此送货单已隐藏价格 — 以下数字会保存，但不会出现在 PDF 或 Word 文件中。',
    generating: '生成中…',
    previewPdf: '预览 / 打印 PDF',
    downloadWord: '下载 Word (.docx)',
    pickSavedItem: '选择已保存的项目',
    noSavedItems: '暂无已保存的项目。',
    manageItems: '管理项目',
    searchItemsPh: '搜索项目…',
    itemNeedsDescription: '项目 {n} 需要填写描述',
    docUpdated: '文档已更新！',
    docCreated: '文档已创建！',
    errorSaving: '保存出错',
    pdfFailed: '无法生成 PDF',
    wordFailed: '无法生成 Word 文件',
    addDescriptionFirst: '请先添加描述',
    savedToLibrary: '已保存到项目库',
    couldNotSaveItem: '无法保存项目',
  },
  docView: {
    back: '返回',
    issuedOn: '开具于 {date}',
    statusUpdated: '状态已更新为{s}',
    converted: '已转换为{t}！',
    duplicated: '文档已复制！',
    deleteConfirm: '永久删除此文档？',
    notFound: '未找到文档。',
    from: '开票方',
    supplier: '供应商',
    billedTo: '收单方',
    updateStatus: '更新状态',
    dates: '日期',
    linkedDocument: '关联文档',
    paymentDetails: '付款信息',
    bank: '银行',
    account: '账号',
    name: '户名',
    notes: '备注',
    terms: '条款与条件',
    pricesHiddenView: '此送货单已隐藏价格。',
    convertDocument: '转换文档',
    convertIntro: '将 {n} 转换为新的文档类型。原文档将被标记为已接受。',
    convertTo: '转换为',
    convert: '转换',
    duplicate: '复制',
  },
  clients: {
    title: '客户',
    count: '{n} 位客户',
    addClient: '添加客户',
    empty: '还没有客户。添加您的第一位客户以开始使用。',
    editClient: '编辑客户',
    fullName: '姓名 *',
    company: '公司',
    email: '电子邮箱',
    phone: '电话',
    address: '地址',
    city: '城市',
    notes: '备注',
    notesPh: '关于此客户的任何备注…',
    updated: '客户已更新！',
    added: '客户已添加！',
    deleted: '客户已删除',
    confirmDelete: '删除此客户？',
  },
  items: {
    title: '项目',
    count: '{n} 个已保存项目',
    importBtn: '从文档导入',
    addItem: '添加项目',
    searchPh: '按描述、SKU、供应商、品牌、类别搜索…',
    empty: '还没有已保存的项目。添加可重复使用的产品或服务，加快单据创建速度。',
    noMatch: '没有与“{q}”匹配的项目。',
    unitPrice: '单价',
    unit: '单位',
    inStock: '库存',
    supplier: '供应商',
    editItem: '编辑项目',
    description: '描述 *',
    descriptionPh: '网站设计套餐',
    unitPriceLabel: '单价（{s}）',
    costPriceLabel: '成本价（{s}）',
    taxRate: '税率 (%)',
    unitLabel: '单位',
    unitPh: '小时、件、天…',
    category: '类别',
    categoryPh: '服务、产品…',
    stockQty: '库存数量',
    sku: 'SKU',
    skuPh: '产品编码',
    barcode: '条形码',
    barcodePh: 'UPC / EAN',
    brand: '品牌',
    notes: '备注',
    notesPh: '关于此项目的任何内部备注…',
    updated: '项目已更新！',
    added: '项目已添加！',
    deleted: '项目已删除',
    confirmDelete: '删除此项目？',
    errorSaving: '保存出错',
    aiPaidOnly: 'AI 导入为付费功能。请在“订阅”页面升级后使用。',
    importTitle: '从文档导入项目',
    importIntro: '上传 PDF、图片、Excel（.xlsx/.xls）或 CSV 文件。AI OCR 将提取项目，您可以在保存前查看和编辑。',
    takePhoto: '拍照',
    noneDetected: '未在此文档中检测到项目。',
    extractionFailed: '提取失败。',
    cameraFailed: '相机启动失败。',
    foundSelected: '找到 {n} 个项目 · 已选择 {c} 个',
    selectAll: '全选',
    clear: '清除',
    thDescription: '描述', thUnitPrice: '单价', thCost: '成本', thUnit: '单位',
    thSku: 'SKU', thCategory: '类别', thBrand: '品牌', thSupplier: '供应商',
    thTax: '税率 %', thQty: '数量',
    working: '处理中…',
    saveCount: '保存 {n} 个项目',
    selectAtLeastOne: '请至少选择一个项目',
    imported: '已导入 {n} 个项目',
    importFailed: '导入失败',
  },
  profile: {
    title: '我的资料',
    subtitle: '管理您的账户信息和安全设置',
    accountInfo: '账户信息',
    accountInfoSub: '更新您的姓名和电子邮箱',
    emailChangeHint: '为了您的安全，更改邮箱需要输入密码。我们会向新地址发送确认链接——在您确认之前，当前邮箱仍然有效。',
    emailNeedsPassword: '请输入当前密码以更改邮箱。',
    sendConfirmation: '发送确认',
    emailConfirmSent: '确认邮件已发送至 {email}。点击其中的链接以完成更改——在此之前当前邮箱仍然有效。',
    emailPending: '更改为 {email} 正在等待确认——请查收该邮箱中的确认链接。',
    cancelEmailChange: '取消更改邮箱',
    emailChangeCancelled: '已取消更改邮箱',
    uploadPhoto: '上传照片',
    changePhoto: '更换照片',
    removePhoto: '移除',
    photoUpdated: '头像已更新',
    photoRemoved: '头像已移除',
    photoTooLarge: '图片太大。请使用小于 1 MB 的图片。',
    fullName: '姓名',
    fullNamePh: '您的姓名',
    email: '电子邮箱',
    updated: '资料已更新！',
    updateFailed: '资料更新失败',
    changePassword: '修改密码',
    changePasswordSub: '请使用至少 6 个字符的强密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    noMatch: '两次输入的密码不一致',
    weakPassword: '新密码不符合安全要求。',
    changed: '密码修改成功！',
    changeFailed: '密码修改失败',
    updating: '更新中…',
    updatePassword: '更新密码',
    session: '会话',
    sessionSub: '管理当前登录会话',
    signedInAs: '登录身份',
    thisDevice: '当前设备',
    memberSince: '注册于',
    protected: '已启用',
    signOutOf: '退出 Invio',
    redirected: '您将被跳转到登录页面。',
    accountType: '账户类型',
    standard: '标准',
    plan: '套餐',
    comingSoon: '即将推出',
    photoUpload: '上传头像',
    twoFactor: '双重验证',
    emailNotifications: '邮件通知',
    sessionMgmt: '活动会话管理',
  },
  settings: {
    title: '设置',
    subtitle: '配置公司资料和单据默认设置',
    saveSettings: '保存设置',
    saved: '设置已保存！',
    companyLogo: '公司标志',
    preview: '预览',
    uploadImage: '上传图片',
    removeWhiteBg: '去除白色背景',
    remove: '移除',
    logoHeight: '标志高度（px）',
    previewNote: '预览显示在深色背景上，与 PDF 页眉一致。',
    whiteBgRemoved: '白色背景已去除 — 请记得保存',
    logoProcessFailed: '无法处理标志图片',
    companyInfo: '公司信息',
    companyName: '公司名称 *',
    address: '地址',
    cityState: '城市 / 州',
    phone: '电话',
    email: '电子邮箱',
    website: '网站',
    regNo: '注册号',
    taxNo: '税号 / SST',
    docAppearance: '单据外观',
    docAppearanceIntro: '应用于您生成的每份单据，包括 PDF 和 Word 文件。',
    templateGallery: 'PDF 模板',
    templateGalleryHint: '为您的 PDF 单据选择视觉样式。Word 下载始终使用经典版式。',
    tplClassic: '经典',
    tplMinimal: '简约',
    tplBold: '醒目',
    tplElegant: '优雅',
    tplGradient: '渐变',
    tplSlate: '石板',
    tplSoft: '柔和',
    tplStripe: '条纹',
    tplFrame: '边框',
    tplMono: '黑白',
    tplSidebar: '侧边',
    tplLedger: '账本',
    tplSlim: '纤细',
    tplCurve: '弧形',
    tplDiagonal: '斜切',
    tplBanner: '横幅',
    tplDuo: '双色',
    tplCards: '卡片',
    tplPop: '波普',
    tplRoyal: '皇家',
    tplMarker: '荧光笔',
    tplSketch: '手绘',
    tplGhost: '描边',
    tplMidnight: '午夜',
    colorPresets: '配色方案',
    colorPresetsHint: '一键应用的颜色组合，可搭配任意所选模板 — 也可在下方微调。',
    presetNavy: '藏青',
    presetSky: '天蓝',
    presetTeal: '青绿',
    presetEmerald: '翡翠',
    presetBurgundy: '酒红',
    presetCrimson: '绯红',
    presetCopper: '铜棕',
    presetPlum: '紫罗兰',
    presetRose: '玫红',
    presetGraphite: '石墨',
    headerColour: '页眉颜色',
    accentColour: '强调色',
    hexInvalid: '需要 6 位十六进制值，如 #1A3C6E — 否则将使用默认值。',
    font: '字体',
    bodySize: '正文字号（px）',
    headerSizePct: '页眉大小（%）',
    headerTextSizes: '页眉文字大小（px）— 分别设置页眉中每个文本框',
    hCompanyName: '公司名称',
    hTagline: '网站 / 标语',
    hContact: '联系信息',
    hDocTitle: '单据标题',
    hMeta: '编号 / 日期行',
    compactHeader: '紧凑页眉',
    compactHeaderHint: ' — 将联系信息移到网站下方、标志旁边，以节省垂直空间',
    partySection: '“致 / 签发方”区域',
    partyLabels: '标签（px）',
    partyNames: '名称（px）',
    partyDetails: '详情（px）',
    headerGap: '页眉后间距（px）',
    headerGapHint: '页眉后间距控制页眉色带与此区域之间的距离（0 = 紧贴）。',
    resetTheme: '重置为默认主题',
    currencyDefaults: '货币与默认值',
    defaultCurrency: '默认货币',
    pdfMargin: 'PDF / Word 边距（cm）',
    defaultTerms: '默认条款与条件',
    termsPh: '例如：款项须在 30 天内支付。逾期账户每月收取 1.5% 滞纳金…',
    bankDetails: '银行 / 付款信息',
    bankDetailsIntro: '这些信息将自动显示在所有发票和收据上。',
    bankName: '银行名称',
    accountNumber: '账号',
    accountHolder: '账户持有人姓名',
    signatory: '授权签署人',
    signatoryName: '姓名',
    designation: '职务',
    signatureImage: '电子签名图片',
    noSignature: '暂无签名',
    removeSignature: '移除签名',
    pngRecommended: '建议使用透明背景的 PNG。',
    saveAll: '保存全部设置',
    errorSaving: '保存出错',
  },
  subscription: {
    title: '订阅',
    subtitle: '管理您的 Invio 套餐和账单',
    currentPlan: '当前套餐',
    freeTrial: '免费试用',
    none: '无',
    trialEndsIn: '试用将于以下时间后结束：',
    days: '{d} 天',
    renewsOn: '续订日期：',
    billingHistory: '账单历史',
    subscribedSince: '订阅始于',
    totalPaid: '累计已付',
    payDate: '日期',
    payAmount: '金额',
    payPlan: '方案',
    payStatus: '状态',
    payReceipt: '收据',
    paySucceeded: '已付款',
    payFailed: '失败',
    pastDueMsg: '付款失败。请更新付款方式以继续使用 Invio。',
    manageBilling: '管理账单 →',
    opening: '正在打开…',
    portalUnavailable: '门户不可用',
    activated: '订阅已激活！正在刷新…',
    checkoutCancelled: '结账已取消',
    readyToContinue: '准备好继续使用 Invio 了吗？',
    getInTouch: '联系我们',
    tailorPlan: '我们将为您的业务量身定制套餐。联系我们，我们会帮您完成设置。',
    talkToUs: '联系我们',
    whatsapp: 'WhatsApp',
    choosePlan: '选择套餐',
    upgradeAnytime: '随时升级',
    subscribeMonthly: '按月订阅',
    subscribeYearly: '按年订阅',
    redirecting: '正在跳转…',
    checkoutFailed: '结账失败，请重试。',
    securePayment: '由 Stripe 提供安全支付。可随时取消。',
    needCustom: '需要定制套餐？',
  },
  password: {
    length: '至少 8 个字符',
    lowercase: '一个小写字母',
    uppercase: '一个大写字母',
    digit: '一个数字',
    symbol: '一个符号（如 ! @ # $ %）',
    common: '不是常用密码',
    weak: '弱',
    fair: '一般',
    strong: '强',
    excellent: '极强',
    meetsAll: '满足全部要求',
  },
  server: {
    emailRegistered: '该邮箱已注册',
    invalidCredentials: '邮箱或密码不正确',
    accountDeactivated: '您的账户已被停用。请联系管理员。',
    missingToken: '缺少验证令牌',
    verifyInvalid: '验证链接无效或已被使用',
    verifyExpired: '验证链接已过期。请重新申请。',
    emailRequired: '请输入邮箱',
    resetInvalid: '此密码重置链接无效或已被使用。',
    resetExpired: '此密码重置链接已过期。请重新申请。',
    tooManyRequests: '尝试次数过多。请稍等几分钟后重试。',
    currentPasswordRequired: '需要输入当前密码',
    currentPasswordWrong: '当前密码不正确',
    weakPassword: '密码不符合安全要求。',
    aiPaidOnly: 'AI 功能需要付费订阅。请升级后使用 AI 导入。',
    missingFileData: '缺少文件数据。',
    fileTooLarge: '文件超过 25 MB 限制。',
    itemNotFound: '未找到该项目',
    clientNotFound: '未找到该客户',
    docNotFound: '未找到该单据',
    noStripeCustomer: '尚未关联账单账户。请先订阅。',
    alreadySubscribed: '您已有订阅。请通过“管理账单”进行更改。',
    supportFieldsRequired: '主题和内容为必填项',
    caseNotFound: '未找到该工单',
    caseClosed: '此工单已关闭。请新建工单。',
    caseReopenExpired: '此工单无法重新打开。请新建工单。',
    paymentNotPayable: '只能在发票和账单上记录付款。',
    paymentCancelledDoc: '此文档已取消。',
    paymentInvalidAmount: '请输入大于零的付款金额。',
    paymentExceedsBalance: '付款金额超过应付余额。',
    paymentInvalidDate: '付款日期无效。',
    paymentNotFound: '未找到付款记录。',
    statusPaidByPayments: '此文档已全额付款。请先删除一笔付款再更改状态。',
    shareNotFound: '此链接已失效。',
    shareCannotRespond: '此报价单已无法回复。',
    shareBadAction: '请选择接受或拒绝。',
    shareNameRequired: '请输入您的姓名。',
    sendNotConfigured: '此服务器尚未配置邮件发送。',
    sendVerifyFirst: '发送文档前请先验证您自己的邮箱地址。',
    sendNoRecipient: '请输入收件人邮箱地址。',
    sendTooManyRecipients: '每个字段最多 5 个地址。',
    sendBadRecipient: '其中一个邮箱地址无效。',
    sendDailyLimit: '已达到每日邮件上限，请明天再试。',
    sendFailed: '无法发送邮件。',
    recurringBadFrequency: '未知的周期。',
    recurringNoStart: '请选择首张发票的日期。',
    recurringEndBeforeStart: '结束日期早于首张发票日期。',
    recurringNotInvoice: '只有发票可以设为定期。',
    recurringNotFound: '未找到该计划。',
    einvoiceLocked: '此文档是已提交的 LHDN 电子发票，无法再更改。请在 72 小时内取消电子发票，或开具贷记单。',
    einvDisabled: '尚未开启电子发票。',
    einvNoCredentials: '尚未设置 MyInvois 的 Client ID 和 Secret。',
    einvBadCredentials: 'MyInvois 拒绝了 Client ID / Secret。请检查凭据和环境。',
    einvUnreachable: '无法连接 MyInvois，请重试。',
    einvNotReady: '缺少部分信息。',
    einvAlreadySubmitted: '此文档已提交至 LHDN。',
    einvSubmitFailed: 'MyInvois 未接受此次提交。',
    einvRejected: 'MyInvois 拒绝了该文档。',
    einvNotValid: '只有已验证的电子发票才能取消。',
    einvCancelReason: '请填写取消原因。',
    einvCancelWindow: '72 小时取消期限已过 — 请改为开具贷记单。',
    einvCancelFailed: 'MyInvois 未能取消该文档。',
    einvApiError: 'MyInvois 返回错误，请重试。',
  },
  reset: {
    checking: '正在检查您的重置链接…',
    title: '设置新密码',
    intro: '请为您的 Invio 账户输入新密码。',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    mismatch: '两次输入的密码不一致。',
    submit: '重置密码',
    failedGeneric: '无法重置您的密码。请重试。',
    success: '密码已更新',
    successBody: '您现在可以使用新密码登录。其他设备已退出登录。',
    invalidTitle: '重置链接无效',
    invalidGeneric: '此密码重置链接无效或已过期。',
    requestNew: '重新申请链接',
  },
  verify: {
    verifying: '正在验证您的邮箱…',
    justAMoment: '请稍候。',
    verified: '邮箱已验证',
    confirmed: '已确认。您现在可以正常使用 Invio。',
    continue: '继续前往 Invio →',
    failed: '验证失败',
    failedGeneric: '验证链接无效或已过期。',
    alreadySignedIn: '已登录？您可以通过任意页面顶部的横幅重新申请验证邮件。',
  },
  support: {
    title: '支持',
    subtitle: '提交工单，我们会尽快回复您',
    newCase: '新建工单',
    empty: '还没有支持工单。遇到问题或有疑问？提交工单，我们来帮您。',
    created: '工单 {n} 已创建 — 我们会尽快回复',
    createFailed: '无法创建工单',
    subject: '主题 *',
    subjectPh: '问题的简短描述',
    category: '类别',
    priority: '优先级',
    message: '问题描述 *',
    messagePh: '发生了什么？您期望的结果是什么？复现步骤会很有帮助…',
    attachments: '截图（可选，最多 3 张）',
    attachTooLarge: '图片过大（最大 2 MB）',
    submit: '提交工单',
    yourTurn: '待您回复',
    allCases: '全部工单',
    cat: { billing: '账单与订阅', bug: '故障 / 功能异常', question: '问题 / 使用咨询', feature: '功能建议', other: '其他' },
    status: { open: '已创建', in_progress: '处理中', waiting_on_user: '待您回复', resolved: '已解决', closed: '已关闭' },
    prio: { low: '低', normal: '普通', high: '高' },
    resolvedTitle: '此工单已标记为已解决',
    resolvedAsk: '您的问题解决了吗？',
    confirmClose: '是，关闭工单',
    reopen: '否，重新打开',
    you: '您',
    supportTeam: 'Invio 支持',
    caseClosed: '此工单已关闭。还需要帮助？',
    replyPh: '输入回复…',
    send: '发送',
    sendFailed: '发送失败',
    closedMsg: '工单已关闭 — 感谢反馈！',
    reopenedMsg: '工单已重新打开 — 我们会再次跟进',
  },
  notif: {
    title: '通知',
    empty: '暂无通知',
    justNow: '刚刚',
    minutesAgo: '{n} 分钟前',
    hoursAgo: '{n} 小时前',
    daysAgo: '{n} 天前',
    trialExtended: '您的试用期已延长 {days} 天。🎉',
    trialReminder: '您的试用将在 {days} 天后结束。订阅以继续使用。',
    trialGrace: '您的试用已结束 — 账户锁定前还有 {days} 天宽限期。',
    paymentFailed: '付款失败 — 请在 {days} 天内更新付款方式以保持访问。',
    paymentRecovered: '付款已恢复 — 您的订阅已重新激活。',
    paymentReceipt: '已收到付款：{amount} — 谢谢！收据已发送至您的邮箱。',
    supportReply: '支持团队回复了您的工单 {n}。',
    supportResolved: '您的支持工单 {n} 已解决。',
    supportCase: '来自 {from} 的新支持工单 {n}。',
    supportUserReply: '{from} 回复了支持工单 {n}。',
    docViewed: '{client} 已打开 {n}',
    quoteAccepted: '{client} 已接受报价单 {n}',
    quoteRejected: '{client} 已拒绝报价单 {n}',
    recurringIssued: '已为 {client} 开具定期发票 {n}',
    recurringIssuedSent: '定期发票 {n} 已开具并通过邮件发送给 {client}',
    recurringIssuedError: '定期发票 {n} 已开具，但未发送邮件：{error}',
    invoiceOverdue: '发票 {n} 已逾期',
    invoicesOverdue: '{count} 张发票已逾期',
    einvoiceValid: 'LHDN 已验证电子发票 {n}',
    einvoiceInvalid: 'LHDN 拒绝了电子发票 {n} — 打开查看原因',
  },
  impersonate: {
    banner: '管理员支持会话',
    return: '返回管理员',
  },
  payments: {
    title: '付款记录',
    record: '记录付款',
    none: '尚未记录任何付款。',
    paid: '已付金额',
    balance: '应付余额',
    balanceShort: '余额 {amount}',
    amount: '金额',
    date: '付款日期',
    method: '付款方式',
    reference: '参考编号',
    referencePh: '例如：银行转账参考号',
    note: '备注',
    notePh: '例如：30% 定金',
    payFull: '全部余额',
    save: '保存付款',
    recorded: '付款已记录',
    removed: '付款已删除',
    confirmRemove: '删除此付款记录？',
    failed: '无法保存付款',
    fullyPaid: '已全额付款',
    m_bank_transfer: '银行转账',
    m_cash: '现金',
    m_card: '银行卡',
    m_cheque: '支票',
    m_ewallet: '电子钱包',
    m_online: '在线支付',
    m_other: '其他',
  },
  statement: {
    title: '对账单',
    button: '对账单',
    back: '客户',
    from: '起始日期',
    to: '结束日期',
    currency: '货币',
    thisMonth: '本月',
    lastMonth: '上月',
    thisYear: '今年',
    downloadPdf: '下载 PDF',
    opening: '期初余额',
    closing: '期末余额',
    invoiced: '开票金额',
    paid: '已付',
    credited: '贷记',
    paidCredit: '已付 / 贷记',
    balanceDue: '应付余额',
    balance: '余额',
    date: '日期',
    details: '详情',
    k_invoice: '发票',
    k_payment: '已收款',
    k_credit_note: '贷记单',
    due: '到期日 {date}',
    empty: '此期间没有交易。',
    aging: '按账龄划分的未付金额',
    current: '未到期',
    days: '{range} 天',
    loadFailed: '无法加载对账单',
  },
  share: {
    send: '发送',
    title: '发送 {n}',
    cardTitle: '分享',
    linkTitle: '公开链接',
    linkHelp: '任何拥有此链接的人都可以查看文档并下载 PDF，无需登录。',
    createLink: '创建链接',
    copy: '复制',
    copied: '链接已复制',
    open: '打开',
    disable: '关闭链接',
    disableConfirm: '关闭此链接？已获得链接的人将无法再打开。',
    disabled: '链接已关闭',
    whatsapp: '通过 WhatsApp 分享',
    whatsappText: '{name} 您好，这是来自 {company} 的{type} {n}：\n{url}',
    emailTitle: '通过电子邮件发送给客户',
    to: '收件人',
    cc: '抄送（可选）',
    ccPh: 'accounts@client.com, you@company.com',
    subject: '主题',
    message: '正文',
    defaultSubject: '来自 {company} 的{type} {n}',
    defaultMessage: '{name} 您好，\n\n随信附上{type} {n}，请查收。\n\n谢谢，\n{sender}',
    attachPdf: '附上 PDF',
    includeLink: '包含“在线查看”按钮',
    replyNote: '以贵公司名义发送。回复将发送至 {email}。',
    sendEmail: '发送邮件',
    sending: '正在发送…',
    sent: '邮件已发送至 {to}',
    sendFailed: '无法发送邮件',
    linkFailed: '无法创建链接',
    linkOn: '公开链接已开启',
    linkOff: '尚未分享',
    views: '已查看 {n} 次',
    notViewed: '尚未查看',
    lastViewed: '最近查看：{date}',
    lastEmailed: '已于 {date} 发送邮件至 {to}',
    responded_accepted: '{name} 已于 {date} 接受',
    responded_rejected: '{name} 已于 {date} 拒绝',
    reminderSubject: '提醒：来自 {company} 的{type} {n}',
    reminderMessage: '{name} 您好，\n\n温馨提醒：{type} {n} 尚未付款，可能只是被遗漏了。\n\n如果您已付款，请忽略此邮件，谢谢。\n\n此致，\n{sender}',
  },
  publicDoc: {
    loading: '正在加载文档…',
    notFoundTitle: '此链接已失效',
    notFoundBody: '发送方可能已将其关闭，请向对方索取新链接。',
    from: '发件方',
    to: '收件方',
    issued: '开具日期',
    due: '到期日',
    validUntil: '有效期至',
    downloadPdf: '下载 PDF',
    preparing: '正在准备…',
    pdfFailed: '无法生成 PDF，请重试。',
    amountDue: '应付金额',
    paidInFull: '已全额付款，谢谢！',
    howToPay: '付款方式',
    acceptTitle: '回复此报价单',
    yourName: '您的全名',
    accept: '接受报价',
    decline: '拒绝',
    declineConfirm: '拒绝此报价单？',
    acceptNote: '接受即表示您确认上述项目、价格和条款。',
    accepted: '{name} 已于 {date} 接受',
    rejected: '{name} 已于 {date} 拒绝',
    respondFailed: '无法保存您的回复，请重试。',
    poweredBy: '由 Invio 发送 — 免费试用 30 天，创建您自己的发票',
    regNo: '注册号',
    taxNo: '税号',
  },
  recurring: {
    title: '定期发票',
    subtitle: '按计划自动开具的发票',
    empty: '尚无定期发票。打开任意发票并选择“设为定期”。',
    goInvoices: '前往发票',
    make: '设为定期',
    modalTitle: '重复 {n}',
    modalIntro: 'Invio 将按此计划开具包含相同项目的新发票。当前发票不会被更改。',
    frequency: '重复周期',
    every: '每',
    f_weekly: '周',
    f_monthly: '个月',
    f_quarterly: '个季度',
    f_yearly: '年',
    firstInvoice: '首张发票日期',
    endDate: '结束日期（可选）',
    dueDays: '付款期限（天）',
    autoSend: '自动将每张发票通过电子邮件发送给客户',
    autoSendHelp: '关闭：发票将创建为草稿，供您审核后发送。',
    noClientEmail: '此客户没有邮箱地址 — 请添加后再使用自动发送。',
    create: '启动计划',
    created: '定期发票已设置。下一张：{date}',
    saved: '计划已更新',
    failed: '无法保存计划',
    thClient: '客户 / 发票',
    thAmount: '金额',
    thSchedule: '计划',
    thNext: '下一张发票',
    thStatus: '状态',
    summary: '每 {n} {unit}',
    issued: '已开具 {n} 张',
    last: '上一张：{n}',
    until: '至 {date}',
    autoSendOn: '自动发送',
    asDraft: '创建草稿',
    s_active: '进行中',
    s_paused: '已暂停',
    s_ended: '已结束',
    pause: '暂停',
    resume: '恢复',
    runNow: '立即开具',
    runConfirm: '立即开具下一张发票？',
    ran: '已开具 {n}',
    deleteConfirm: '删除此计划？已开具的发票将保留。',
    deleted: '计划已删除',
    lastError: '上次运行：{msg}',
    fromSchedule: '由定期计划开具',
    basedOn: '基于 {n}',
  },
  reminders: {
    title: '付款提醒',
    intro: '当发票即将到期或已逾期时，Invio 可自动向您的客户发送邮件。邮件以贵公司名义发出并附发票链接；回复会发送给您。无论是否开启提醒，发票都会自动标记为逾期。',
    enable: '自动向客户发送付款提醒',
    before: '到期前天数（0 = 关闭）',
    after: '到期后天数',
    afterHelp: '以逗号分隔，例如 1, 7, 14',
    needsEmail: '只有客户留有邮箱地址的发票才会收到提醒。您可以在发票页面上排除单张发票。',
    docToggle: '此发票不发送自动提醒',
    docSent: '已发送提醒：{n} 次',
    updated: '提醒设置已保存',
  },
  onboarding: {
    title: '开始使用 Invio',
    subtitle: '四个简单步骤，开具第一张带有您自己徽标的发票。',
    progress: '已完成 {done}/{total}',
    dismiss: '隐藏',
    s_company: '添加公司信息',
    d_company: '您的名称和徽标将显示在每份文档上。',
    s_client: '添加第一位客户',
    d_client: '保存一次客户信息，即可在每份报价单和发票中重复使用。',
    s_document: '创建第一张发票或报价单',
    d_document: '选择客户、添加项目即可完成。随时导出为 PDF 或 Word。',
    s_sent: '发送给客户',
    d_sent: '通过附带 PDF 的电子邮件、WhatsApp 或链接发送 — 并查看对方何时打开。',
    companyName: '公司名称',
    phone: '电话',
    logo: '徽标（可选）',
    saveCompany: '保存',
    moreSettings: '更多设置',
    companySaved: '公司信息已保存',
    addClient: '添加客户',
    newInvoice: '新建发票',
    newQuotation: '新建报价单',
    openDocs: '打开我的文档',
    sampleTitle: '只想看看效果？',
    sampleBody: '一键创建示例发票，并以带有您品牌的 PDF 打开。它始终是草稿 — 可随时删除。',
    sampleCreate: '创建示例发票',
    sampleOpen: '打开示例发票',
    sampleFailed: '无法创建示例',
    sampleBanner: '这是一张示例发票。试试 PDF 和发送按钮，然后将其删除 — 它是草稿，不会影响您的数据。',
  },
  einv: {
    title: 'LHDN 电子发票 (MyInvois)',
    subtitle: '直接从 Invio 向 LHDN 提交发票和贷记单进行验证',
    back: '设置',
    settingsIntro: '马来西亚正分阶段强制推行电子发票。连接您的 MyInvois 账户后，Invio 会将发票提交至 LHDN，并在 PDF 上附上验证二维码。',
    open: '设置电子发票',
    statusOn: '已开启 — {env}',
    statusOff: '尚未设置',
    stepsTitle: '如何连接',
    step1: '登录 MyInvois 门户（先使用沙盒环境：preprod.myinvois.hasil.gov.my）。',
    step2: '打开纳税人资料 → Representatives → Register ERP，命名为“Invio”。',
    step3: '复制显示的 Client ID 和 Client Secret（密钥仅显示一次），粘贴到下方。',
    step4: '测试连接，在沙盒中提交一张测试发票，然后使用正式密钥切换到 Production。',
    enable: '启用 LHDN 电子发票',
    connection: 'MyInvois 连接',
    environment: '环境',
    sandbox: '沙盒（测试）',
    production: '正式环境（真实电子发票）',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    secretSaved: '已保存 — 留空则保持不变',
    secretNote: '加密存储，不会再次显示，也不会回传到您的浏览器。',
    test: '测试连接',
    testing: '正在测试…',
    testOk: '已连接到 MyInvois（{env}）。',
    testTinValid: '您的 TIN 和注册号与 LHDN 记录相符。',
    testTinInvalid: '已连接，但 LHDN 无法识别此 TIN 与注册号的组合。',
    saveFirst: '请先保存设置，然后再测试。',
    supplier: '您的税务信息',
    supplierNote: '公司名称、地址、城市和邮箱取自主设置。',
    tin: 'TIN（税务识别号）',
    idType: '证件类型',
    id_BRN: '商业注册号 (BRN)',
    id_NRIC: '身份证 (NRIC)',
    id_PASSPORT: '护照',
    id_ARMY: '军人证',
    idValue: '证件 / 注册号码',
    sstNo: 'SST 注册号（如已注册）',
    ttxNo: '旅游税号（如有）',
    msic: 'MSIC 代码（5 位）',
    msicHelp: '可在 MyInvois 门户资料或 LHDN 的 MSIC 列表中查找。',
    activity: '业务活动描述',
    postcode: '邮编',
    state: '州属',
    chooseState: '选择州属…',
    phone: '联系电话',
    defaults: '每张电子发票的默认值',
    classification: '销售内容分类',
    classificationHelp: '“022 Others”适用于大多数企业。提交时可按发票更改。',
    taxType: '您收取的税种（发票含税时）',
    taxNone: '我不收取税费',
    tax_01: '销售税',
    tax_02: '服务税',
    save: '保存电子发票设置',
    saved: '电子发票设置已保存',
    versionNote: 'Invio 提交文档版本 1.0，LHDN 接受该版本且无需数字证书。待 LHDN 停用 1.0 后将支持 1.1（数字签名）。',
    clientSection: '电子发票信息 (LHDN)',
    clientSectionHelp: '仅在为此客户提交电子发票时需要。',
    buyerTin: '客户 TIN',
    generalPublic: '无 TIN — 马来西亚个人',
    generalForeign: '无 TIN — 外国买家',
    country: '国家（3 位字母代码）',
    checkTin: '向 LHDN 核验',
    tinValid: 'LHDN 认可此 TIN 和证件号。',
    tinInvalid: 'LHDN 无法识别此 TIN 与证件号的组合。',
    card: 'LHDN 电子发票',
    st_none: '未提交',
    st_submitted: '已提交 — 等待 LHDN',
    st_valid: 'LHDN 已验证',
    st_invalid: '被 LHDN 拒绝',
    st_cancelled: '电子发票已取消',
    submit: '提交至 LHDN',
    resubmit: '修正后重新提交',
    submitting: '正在提交…',
    refresh: '查看状态',
    viewOnPortal: '在 MyInvois 查看',
    uuid: 'UUID',
    validatedOn: '验证时间 {date}',
    sandboxBadge: '沙盒',
    locked: '此文档已锁定：LHDN 验证的内容必须与客户持有的一致。如需更改，请在 72 小时内取消电子发票，或开具贷记单。',
    modalTitle: '将 {n} 提交至 LHDN',
    modalIntro: 'LHDN 会在数秒内验证电子发票。验证后文档将被锁定，PDF 将带有 LHDN 二维码。',
    sandboxWarning: '沙盒模式：这是测试提交，不具法律效力。',
    productionWarning: '正式环境：这是向 LHDN 申报的真实电子发票。',
    fixFirst: '请先修正以下问题：',
    fixInSettings: '电子发票设置',
    fixInClient: '编辑客户',
    exchangeRate: '汇率：1 {cur} = ? MYR',
    notEnabled: '尚未设置电子发票。',
    done_valid: 'LHDN 已验证 ✓',
    done_submitted: '已提交。LHDN 仍在验证 — 请稍后查看状态。',
    done_invalid: 'LHDN 拒绝了该电子发票 — 请在文档上查看原因。',
    failed: '无法提交至 LHDN',
    cancel: '取消电子发票',
    cancelTitle: '取消 LHDN 电子发票',
    cancelIntro: 'LHDN 允许在验证后 72 小时内取消。超过期限请改为开具贷记单。LHDN 会通知您的客户。',
    cancelReason: '原因',
    cancelReasonPh: '例如：金额有误',
    cancelled: '电子发票已取消',
    publicBadge: '已验证的 LHDN 电子发票',
    publicVerify: '在 MyInvois 验证',
  },
  einvP: {
    einvType: '只有发票和贷记单可以作为电子发票提交。',
    einvCancelledDoc: '此文档已取消。',
    einvNoItems: '文档没有任何项目。',
    einvItemDescription: '每个项目都需要描述。',
    einvSupplierTin: '您的 TIN 缺失或无效。',
    einvSupplierId: '缺少您的商业注册号 / 证件号。',
    einvMsic: '缺少您的 5 位 MSIC 代码。',
    einvActivity: '缺少您的业务活动描述。',
    einvSupplierName: '缺少公司名称（设置）。',
    einvSupplierAddress: '缺少公司地址（设置）。',
    einvSupplierCity: '缺少公司所在城市（设置）。',
    einvSupplierState: '请选择您的州属。',
    einvSupplierPhone: '缺少您的联系电话。',
    einvNoClient: '请将此文档关联到客户。',
    einvBuyerTin: '缺少客户的 TIN（无 TIN 的买家请使用通用 TIN）。',
    einvBuyerId: '缺少客户的注册号 / 证件号。',
    einvBuyerAddress: '缺少客户地址。',
    einvBuyerCity: '缺少客户所在城市。',
    einvBuyerState: '请选择客户的州属。',
    einvBuyerCountry: '客户国家必须为 3 位字母代码（如 MYS）。',
    einvBuyerPhone: '缺少客户电话号码。',
    einvExchangeRate: '请输入兑换 MYR 的汇率。',
    einvTaxType: '请选择您收取的是销售税还是服务税。',
    einvSstNo: '收取税费时必须填写 SST 注册号。',
    einvOriginal: '贷记单必须由已验证的电子发票创建。',
  },
  common: {
    save: '保存',
    saving: '保存中…',
    cancel: '取消',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    loading: '加载中…',
    welcome: '您好',
    overview: '这是您的业务概览',
    language: '语言',
  },
};
export default zh;
